var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { uniq } from '../../../../../utils/helper/lodash_replacements';
export class ChannelInfo {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get channel() {
        return this.parent;
    }
    get incomingIntents() {
        return this.channel.intentsByState.pendingIntents;
    }
    get silenceSinceSeconds() {
        if (this.channel.intentsByState.playingAndStartedIntents.length > 0)
            return 0;
        let minSeconds = 99999;
        this.channel.intentsByState.completedIntents.forEach(intent => {
            if (intent.intentInfo.isIntentCompleted && intent.intentInfo.secondsSinceComplete < minSeconds) {
                minSeconds = intent.intentInfo.secondsSinceComplete;
            }
        });
        return minSeconds;
    }
    get isChannelFree() {
        return this.channel.intentsByState.playingAndStartedIntents.length === 0;
    }
    get isChannelCurrentlyPlaying() {
        return !this.isChannelFree;
    }
    get remainingBusyTimeInSeconds() {
        const { playingIntents, startedIntents, pendingIntents } = this.channel.intentsByState;
        const onGoingIntents = [...playingIntents, ...startedIntents];
        const relevantIntents = [...onGoingIntents];
        if (onGoingIntents.length > 0 || pendingIntents.find(intent => intent.intentStart.shouldStart)) {
            relevantIntents.push(...pendingIntents);
        }
        return uniq(relevantIntents)
            .map(intent => intent.intentInfo.remainingSeconds)
            .reduce((a, b) => a + b, 0);
    }
}
__decorate([
    computed
], ChannelInfo.prototype, "incomingIntents", null);
__decorate([
    computed
], ChannelInfo.prototype, "silenceSinceSeconds", null);
__decorate([
    computed
], ChannelInfo.prototype, "isChannelFree", null);
